import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-comparison-badge',
  templateUrl: './comparison-badge.component.html',
  styleUrl: './comparison-badge.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ComparisonBadgeComponent {
  @Input() value: number | null = null;
  @Input() digits = 1;
  @Input() prefix = '';
  @Input() suffix = '';

  get state(): 'up' | 'down' | 'flat' | 'none' {
    const rounded = this.roundedValue;
    if (rounded === null) return 'none';

    if (rounded > 0) return 'up';
    if (rounded < 0) return 'down';
    return 'flat';
  }

  get label(): string {
    const rounded = this.roundedValue;
    if (rounded === null) return '—';

    const sign = rounded > 0 ? '+' : rounded < 0 ? '−' : '';
    return `${sign}${this.prefix}${Math.abs(rounded).toFixed(this.digits)}${this.suffix}`;
  }

  private get roundedValue(): number | null {
    return this.value === null ? null : Number(this.value.toFixed(this.digits));
  }
}
